import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, VStack } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import ConfigChange from './ConfigChange';
import { useDispatch } from 'react-redux';
import { getBasicUserDetail } from '../../actions/users';
import { Pagination } from '@codametrix/ui-components';
const userCache = {};
const ConfigChangeList = ({ changes, auditData, onPageChange })=>{
    const dispatch = useDispatch();
    const [userDetailsMap, setUserDetailsMap] = useState({});
    useEffect(()=>{
        const fetchMissingUserDetails = async ()=>{
            const uniqueIds = Array.from(new Set(changes.map((c)=>c.userName).filter(Boolean)));
            const uncachedIds = uniqueIds.filter((id)=>!userCache[id]);
            const promises = uncachedIds.map(async (userId)=>{
                try {
                    const result = await dispatch(getBasicUserDetail({
                        userId
                    }));
                    userCache[userId] = result;
                } catch (e) {
                    console.error(`Failed to fetch user ${userId}`, e);
                    userCache[userId] = {
                        username: userId,
                        firstName: '',
                        lastName: ''
                    }; // fallback
                }
            });
            await Promise.all(promises);
            setUserDetailsMap({
                ...userCache
            });
        };
        fetchMissingUserDetails();
    }, [
        changes,
        dispatch
    ]);
    const handlePageChange = (action)=>{
        const newPage = action.index + 1;
        onPageChange(newPage);
    };
    return /*#__PURE__*/ _jsxs(VStack, {
        spacing: 4,
        align: "stretch",
        flex: "1",
        minH: 0,
        maxH: "100%",
        h: "100%",
        overflow: "hidden",
        children: [
            /*#__PURE__*/ _jsx(Box, {
                flex: "1",
                minH: 0,
                overflowY: "auto",
                overflowX: "hidden",
                children: /*#__PURE__*/ _jsx(VStack, {
                    spacing: 4,
                    align: "stretch",
                    pb: 2,
                    children: changes.map((change, index)=>/*#__PURE__*/ _jsx(ConfigChange, {
                            change: change,
                            userDetails: userDetailsMap[change.userName ?? '']
                        }, index))
                })
            }),
            /*#__PURE__*/ _jsx(Box, {
                flexShrink: 0,
                pt: 4,
                borderTopWidth: "1px",
                borderColor: "gray.100",
                children: /*#__PURE__*/ _jsx(Pagination, {
                    pageable: auditData,
                    onSelect: handlePageChange,
                    theme: "cmx-theme"
                })
            })
        ]
    });
};
export default ConfigChangeList;
